import React from 'react'
import './Pagination.css'

function Pagination({ currentPage, totalPages, onPageChange }) {
  const getPageNumbers = () => {
    const pages = []
    const maxVisible = 5 // Màxim de números de pàgina visibles

    if (totalPages <= maxVisible) {
      // Si hi ha poques pàgines, mostrar totes
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i)
      }
    } else {
      // Lògica per mostrar pàgines amb ellipsis
      if (currentPage <= 3) {
        // A prop de l'inici
        for (let i = 1; i <= 4; i++) {
          pages.push(i)
        }
        pages.push('ellipsis')
        pages.push(totalPages)
      } else if (currentPage >= totalPages - 2) {
        // A prop del final
        pages.push(1)
        pages.push('ellipsis')
        for (let i = totalPages - 3; i <= totalPages; i++) {
          pages.push(i)
        }
      } else {
        // Al mig
        pages.push(1)
        pages.push('ellipsis')
        for (let i = currentPage - 1; i <= currentPage + 1; i++) {
          pages.push(i)
        }
        pages.push('ellipsis')
        pages.push(totalPages)
      }
    }

    return pages
  }

  return (
    <div className='pagination-container'>
      {/* First */}
      <button className='pagination-btn' onClick={() => onPageChange(1)} disabled={currentPage === 1} aria-label='Primera página'>
        «
      </button>

      {/* Previous */}
      <button className='pagination-btn' onClick={() => onPageChange(currentPage - 1)} disabled={currentPage === 1} aria-label='Página anterior'>
        ‹
      </button>

      {/* Page Numbers */}
      {getPageNumbers().map((page, index) => {
        if (page === 'ellipsis') {
          return (
            <span key={`ellipsis-${index}`} className='pagination-ellipsis'>
              ...
            </span>
          )
        }

        return (
          <button key={page} className={`pagination-btn ${currentPage === page ? 'active' : ''}`} onClick={() => onPageChange(page)}>
            {page}
          </button>
        )
      })}

      {/* Next */}
      <button className='pagination-btn' onClick={() => onPageChange(currentPage + 1)} disabled={currentPage === totalPages} aria-label='Página siguiente'>
        ›
      </button>

      {/* Last */}
      <button className='pagination-btn' onClick={() => onPageChange(totalPages)} disabled={currentPage === totalPages} aria-label='Última página'>
        »
      </button>
    </div>
  )
}

export default Pagination
